import {PopQuizRecommendedAssessment} from './types';

/**
 * Selects a single assessment to recommend for the given course topic id.
 * Filters out inactive Assessments and picks the first match
 */
export function selectRecommendedAssessment(
    all: PopQuizRecommendedAssessment[],
    courseTopicId: string | null,
): PopQuizRecommendedAssessment | undefined {
    if (!courseTopicId) {
        return undefined;
    }
    return all.find(
        (assessment) => assessment.isActive && assessment.topicIds.includes(courseTopicId),
    );
}
